import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getAgencies,
  clearAgencies,
  getVisibleAgencies,
  getAgenciesAssignedToUser,
} from '../../../../actions/index';
import Select from './Select';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { optionsPropTypes } from './SelectPropTypes';

const AgencySelect = ({
  dispatchGetAgencies,
  clearAllAgencies,
  showOptions,
  dispatchClearAgencies,
  dispatchGetVisibleAgencies,
  agencies,
  isLoading,
  isMulti,
  input,
  meta,
  isDisabled,
  isClearable,
  visibilityRestricted,
  dispatchGetAgenciesAssignedToUser,
  onlyUserAgencies
}) => {


  useLayoutEffect(() => {

    if (onlyUserAgencies) {
      dispatchGetAgenciesAssignedToUser();
    }

    return () => {
      if (clearAllAgencies) dispatchClearAgencies();
    }

  }, [])

  const handleInputChange = (inputValue) => {
    if (onlyUserAgencies) return;

    if (inputValue.trim().length && inputValue.trim().length >= 3) {
      if (visibilityRestricted) {
        dispatchGetVisibleAgencies({ query: inputValue });
      } else {
        dispatchGetAgencies({ query: inputValue });
      }
    }
  };

  const agencyFilterOption = (options) => options;

  return (
    <Select
      options={!showOptions.length ? agencies : showOptions}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
      isClearable={isClearable}
      isDisabled={isDisabled}
      onInputChange={handleInputChange}
      filterOption={agencyFilterOption}
      placeholder="Ingrese ubicación"
    />
  );
};

AgencySelect.propTypes = {
  dispatchGetAgencies: PropTypes.func.isRequired,
  dispatchClearAgencies: PropTypes.func.isRequired,
  dispatchGetVisibleAgencies: PropTypes.func.isRequired,
  dispatchGetAgenciesAssignedToUser: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  agencies: optionsPropTypes,
  meta: metaPropTypes,
  showOptions: PropTypes.instanceOf(Array),
  clearAllAgencies: PropTypes.bool,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isClearable: PropTypes.bool,
  visibilityRestricted: PropTypes.bool,
  onlyUserAgencies: PropTypes.bool,
};

AgencySelect.defaultProps = {
  isLoading: false,
  isDisabled: false,
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isClearable: false,
  clearAllAgencies: true,
  showOptions: [],
  isMulti: false,
  agencies: [],
  visibilityRestricted: false,
  onlyUserAgencies: false,
};

const mapStateToProps = ({ HumanResourcesUnit }) => ({
  agencies: HumanResourcesUnit.Agency.getIn(['all', 'content', 'content']).map(
    (agency) => ({ ...agency, value: agency.id, label: agency.name }),
  ),
  isLoading: HumanResourcesUnit.Agency.getIn(['all', 'loading']),
});

const mapDispatchToprops = {
  dispatchGetAgencies: getAgencies,
  dispatchGetVisibleAgencies: getVisibleAgencies,
  dispatchClearAgencies: clearAgencies,
  dispatchGetAgenciesAssignedToUser: getAgenciesAssignedToUser
};

export default connect(mapStateToProps, mapDispatchToprops)(AgencySelect);
